module.exports = __webpack_public_path__ + "static/pivonuv-beh-2023-d5f7c0d8965b96d3a145f3b4911616fc.jpg";